import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Elena M.',
  age: 52,
  location: 'Madrid, España',
  quote: 'A mis 52 años, pensaba que los sofocos y la barriga inflamada eran mi nueva realidad. En la primera semana del Código Hormonal, volví a dormir 8 horas seguidas. En 21 días, mis jeans favoritos me quedaban grandes. No pasé hambre ni un solo día.'
}, {
  name: 'Claudia R.',
  age: 48,
  location: 'Miami, USA',
  quote: 'Como ejecutiva, la niebla mental me estaba matando. No podía concentrarme. Este sistema me devolvió la claridad en días. Perdí 6 kilos sin pisar un gimnasio, solo ajustando mis hormonas.'
}];
export function Testimonials() {
  return <section className="bg-warm-white py-20 md:py-28" data-id="element-189">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-191">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-16 text-center" data-id="element-192">
            Historias Reales de Transformación
          </h2>

          <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-193">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="bg-cream p-8 md:p-10 rounded-lg shadow-lg relative" data-id="element-194">
                <QuoteIcon className="w-12 h-12 text-gold/30 absolute top-6 left-6" data-id="element-195" />
                <div className="relative z-10 mt-8" data-id="element-196">
                  <p className="text-lg md:text-xl text-charcoal/90 leading-relaxed mb-6 italic" data-id="element-197">
                    "{testimonial.quote}"
                  </p>
                  <div className="border-t border-charcoal/10 pt-4" data-id="element-198">
                    <p className="font-serif text-xl text-charcoal font-semibold" data-id="element-199">
                      {testimonial.name}, {testimonial.age} años
                    </p>
                    <p className="text-charcoal/60 flex items-center gap-2 mt-2" data-id="element-200">
                      <MapPinIcon className="w-4 h-4" data-id="element-201" />
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}